import * as React from 'react';
import { isServer } from './misc.esm.js';
import { AnalyticsQueue } from './analyticsQueue.esm.js';

/**
 *
 * @param {debug} - log event properties in console
 */
var useAnalyticsQueue = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.debug, debug = _c === void 0 ? false : _c;
    var queue = React.useMemo(function () {
        if (!isServer()) {
            queue === null || queue === void 0 ? void 0 : queue.stop();
            return new AnalyticsQueue(debug);
        }
    }, [debug]);
    React.useEffect(function () {
        return function () { return queue === null || queue === void 0 ? void 0 : queue.stop(); };
    }, [queue]);
    var logEvent = React.useCallback(function (values) { return queue === null || queue === void 0 ? void 0 : queue.logEvent(values); }, [queue]);
    var setUserProperties = React.useCallback(function (values) { return queue === null || queue === void 0 ? void 0 : queue.setUserProperties(values); }, [queue]);
    var pageViewLogEvent = React.useCallback(function (currentPage, eventProperties) { return queue === null || queue === void 0 ? void 0 : queue.pageViewLogEvent(currentPage, eventProperties); }, [queue]);
    var linkClickLogEvent = React.useCallback(function (linkName, currentPage, eventProperties) {
        return queue === null || queue === void 0 ? void 0 : queue.linkClickLogEvent(linkName, currentPage, eventProperties);
    }, [queue]);
    return {
        linkClickLogEvent: linkClickLogEvent,
        logEvent: logEvent,
        pageViewLogEvent: pageViewLogEvent,
        setUserProperties: setUserProperties,
    };
};

export { useAnalyticsQueue as default, useAnalyticsQueue };
//# sourceMappingURL=useAnalyticsQueue.esm.js.map
